import type { StateMessageProps } from "./types-state-message";
import { useStateMessage } from "./use-state-message";
import { StateMessageView } from "./view-state-message";

/** Bloco de carregando / erro / acesso não autorizado / vazio / informação, em cartão ou em linha (`inline`). */
export function StateMessage(props: StateMessageProps) {
  const viewModel = useStateMessage(props);

  return <StateMessageView {...viewModel} />;
}
StateMessage.displayName = "StateMessage";
